import React from 'react';

export default function BlueText(props) {
  return <span className={"bg-gradient-to-r text-transparent bg-clip-text " + (props.light ? "from-teal-200 via-sky-100 to-indigo-100" : "from-teal-300 via-sky-300 to-indigo-300")}>{props.text}</span>
}